import jogoVelha from "../../assets/jogo-da-velha.png"
import jogoMemoria from "../../assets/jogo-da-memoria.png"
import fincheck from "../../assets/fincheck.png"

const projects = [
  {
    href: "https://jogo-da-velha-react-rho.vercel.app/",
    src: jogoVelha,
    alt: "jogo da velha",
    button: {
      private: false,
      href: "https://github.com/WellingtonEduardo/jogo-da-velha-react"
    },
  },
  {

    href: "https://fincheck-front.vercel.app",

    src: fincheck,

    alt: "Ficheck",

    button: {

      private: false,

      href: "https://github.com/WellingtonEduardo/fincheck-api"

    },

  },
  {
    href: "https://jogo-da-memoria-react-two-chi.vercel.app/",
    src: jogoMemoria,
    alt: "jogo da memoria",
    button: {
      private: false,
      href: "https://github.com/WellingtonEduardo/jogo-da-memoria-react"
    },
  },
]




export default projects